import React, { useContext, useState } from "react";
import img1 from "../../assets/images/3dBg.jpg";
import Spacer from "../../components/Utils/Spacer";
import { Context } from "../../context";
import classes from "./Demo.module.css";
import DemoCard2 from "./DemoCard2";

const DemoRequest = () => {
  const { debug, lang } = useContext(Context);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [viewDemo, setViewDemo] = useState(false);
  const [error, setError] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username === "demo" && password === "admin_demo") {
      setViewDemo(true);
    } else {
      setError(true);
    }
  };

  return (
    <>
      <section id="demoHome" className={`${classes.demoHome} section p_zero`}>
        <div className="text-center py-5">
          <div className="container">
            {viewDemo ? (
              <>
                {lang === "en" ? (
                  <>
                    <p style={{ fontSize: "19px", fontWeight: "bold" }}>
                    Some examples of demos of completed projects
                    </p>
                  </>
                ) : (
                  <p style={{ fontSize: "19px", fontWeight: "bold" }}>
                      Alcuni esempi di demo di progetti realizzati
                    </p>
                )}
                <Spacer height={30} />

                <div className="row">
                  <DemoCard2
                    id="1"
                    title="sdfsdfsdf"
                    description="dasdasdas"
                    img={img1}
                    url="asfasd"
                  />
                  <DemoCard2
                    id="2"
                    title="sdfsdfsdf"
                    description="dasdasdas"
                    img={img1}
                    url="asfasd"
                  />
                </div>
              </>
            ) : (
              <>
                <Spacer height={50} />
                {lang === "en" ? (
                  <b style={{ fontSize: "19px" }}>
                    Request a demo of some projects
                  </b>
                ) : (
                  <b style={{ fontSize: "19px" }}>
                    Richiedi la demo di alcuni progetti
                  </b>
                )}
                <Spacer height={28} />
                <div className={`${classes.demoForm}`}>
                  <label>Username</label>
                  <input
                    type="text"
                    value={username}
                    className="form-control"
                    onChange={(e) => setUsername(e.target.value)}
                  />
                  <Spacer height={20} />
                  <label>Password</label>
                  <input
                    type="password"
                    value={password}
                    className="form-control"
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <Spacer height={20} />
                  <input
                    type="submit"
                    value=" Login "
                    onClick={handleSubmit}
                    className={`${classes.buttonForm}`}
                  />
                </div>
                <Spacer height={50} />
                {error && (
                  <b style={{ fontSize: "18px", color: "red" }}>
                    Incorrect data
                  </b>
                )}
                <Spacer height={350} />
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default DemoRequest;
